var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewportStatusTracked = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  x: 4.5,
  y: 4.5,
  fill: "currentColor",
  rx: 7.5
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#090C29",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15.389 9-3.615 5.595a.91.91 0 0 1-.68.43.87.87 0 0 1-.727-.313L8.5 12.545"
}))));
export { SvgViewportStatusTracked as ReactComponent };
export default __webpack_public_path__ + "assets/images/viewport-status-tracked.svg";